<template>
    <rkm-area
        no-margin-top
        title="Atestados"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.atestados"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <template v-if="item.modelo.id === enums.atestadoModelo.PADRAO">
                            <rkm-row>
                                <rkm-col cols="8">
                                    <Item
                                        :get-value="() => item.nome"
                                        label="Nome"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <Item
                                        :get-value="() => item.isAtestadoAcompanhante ? 'Sim' : 'Não'"
                                        label="Acmpanhante"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col
                                    v-if="item.documentoTipoId === enums.documentoTipo.CPF"
                                    cols="2"
                                >
                                    <Item
                                        :get-value="() => item.cpf"
                                        label="CPF"
                                    />
                                </rkm-col>

                                <rkm-col
                                    v-else-if="item.documentoTipoId === enums.documentoTipo.CNS"
                                    cols="2"
                                >
                                    <Item
                                        :get-value="() => item.cns"
                                        label="CNS"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        :get-value="() => item.data"
                                        label="Data"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        :get-value="() => item.horario"
                                        label="Hora"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        :get-value="() => item.dias"
                                        label="Dias"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <Item
                                        :get-value="() => `${item.cid.codigo} - ${item.cid.nome}`"
                                        label="CID 10"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <rkm-row v-else>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.descricao"
                                    label="Descrição"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Enums.
import atestadoModelo from '@/enums/ambulatorio/atestadoModelo'
import documentoTipo from '@/enums/cadastro/documentoTipo'

export default {
    components: {Item},
    data: () => ({
        enums: {
            atestadoModelo,
            documentoTipo,
        },
    }),
    props: {
        item: {type: Object, required: true},
    },
}
</script>